module.exports = __webpack_public_path__ + "img/douyin.51df0faf.png";